export function getTeamById(state, id) {
  return state.team.teams.find(team => team.id === id);
}
